import { ArrowLeft, MapPin, Clock, Users, Shirt } from 'lucide-react';
import { OutfitSuggestions } from './OutfitSuggestions';

interface Props { date?: Date; onBack?: () => void; }

export function EventDetail({ date = new Date(), onBack = () => window.history.back() }: Props) {
  return (
    <div className="flex flex-col h-full bg-[#FAFAF8]">
      <div className="flex items-center gap-3 px-4 py-3">
        <button onClick={onBack} className="p-2 rounded-lg hover:bg-gray-100"><ArrowLeft size={20} /></button>
        <h2 className="font-semibold">{date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</h2>
      </div>
      <div className="flex-1 px-4 pb-24 overflow-y-auto">
        <div className="bg-white p-4 rounded-xl mb-4">
          <h3 className="font-semibold mb-2">Team Meeting</h3>
          <div className="space-y-2 text-sm text-gray-600">
            <div className="flex items-center gap-2"><Clock size={14} /> 10:00 AM - 11:30 AM</div>
            <div className="flex items-center gap-2"><MapPin size={14} /> Office - Conference Room B</div>
            <div className="flex items-center gap-2"><Users size={14} /> 8 attendees</div>
            <div className="flex items-center gap-2"><Shirt size={14} /> Suggested: Business Casual</div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-xl mb-4">
          <p className="text-xs text-gray-400 mb-1">WEATHER</p>
          <p className="text-2xl font-bold">18°C <span className="text-sm font-normal text-gray-400">Clear</span></p>
        </div>
        <h3 className="font-medium mb-3">Outfit Suggestions</h3>
        <OutfitSuggestions occasion="business_casual" />
      </div>
    </div>
  );
}
